// Progressive coloring: red → yellow → green based on a 0–100 percentage.

const COLOR_RED = { r: 235, g: 50, b: 50 };
const COLOR_YELLOW = { r: 255, g: 210, b: 30 };
const COLOR_GREEN = { r: 1, g: 255, b: 130 };

const RED_THRESHOLD_PCT = 40;
const YELLOW_MID_PCT = 70;

const lerp = (a, b, t) => Math.round(a + (b - a) * t);

const lerpColor = (c1, c2, t) => ({
    r: lerp(c1.r, c2.r, t),
    g: lerp(c1.g, c2.g, t),
    b: lerp(c1.b, c2.b, t),
});

const darken = (c, amount = 0.1) => ({
    r: Math.round(c.r * (1 - amount)),
    g: Math.round(c.g * (1 - amount)),
    b: Math.round(c.b * (1 - amount)),
});

const toStr = ({ r, g, b }) => `rgb(${r}, ${g}, ${b})`;

const pctIsMax = (pct) => {
    const p = Math.max(0, Math.min(100, pct));
    return p >= 100;
};

export const pctToRgb = (pct) => {
    const p = Math.max(0, Math.min(100, pct));
    if (p < RED_THRESHOLD_PCT) return { ...COLOR_RED };
    if (p < YELLOW_MID_PCT) {
        const t = (p - RED_THRESHOLD_PCT) / (YELLOW_MID_PCT - RED_THRESHOLD_PCT);
        return lerpColor(COLOR_RED, COLOR_YELLOW, t);
    }
    const t = (p - YELLOW_MID_PCT) / (100 - YELLOW_MID_PCT);
    return lerpColor(COLOR_YELLOW, COLOR_GREEN, t);
};

export const pctToColor = (pct) => {
    if (pctIsMax(pct)) return 'var(--primary-color)';
    return toStr(pctToRgb(pct));
};

export const pctToGaugeGradient = (pct) => {
    if (pctIsMax(pct)) {
        return 'linear-gradient(to left, var(--primary-color), color-mix(in srgb, var(--primary-color) 72%, black))';
    }
    const c = pctToRgb(pct);
    const d = darken(c);
    return `linear-gradient(to left, ${toStr(c)}, ${toStr(d)})`;
};

export const scoreToColor = (scorePct) => pctToColor(scorePct);
